
function usePubsubFunction() {


  const pubsubPublishMethod = async (publishFunction, message, options, payload) => {
    try {
      await publishFunction(message, options, (payload != undefined && payload) ? payload : {})
    } catch (e) {
      console.log("Error in Pubsub", e)
    }
  }

  return pubsubPublishMethod;
}

export default usePubsubFunction;
